import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FiArrowUpRight } from 'react-icons/fi'

// Import your images
import SnorkelingImg from '../../../assets/Scuba diving/img1.jpg'
import ScubaDivingImg from '../../../assets/Scuba diving/img4.jpg'
import CanoeingImg from '../../../assets/Song Phraek/img4.jpg'
import KayakingImg from '../../../assets/Ao Thalane Kayaking/img2.jpg'
import ZiplineImg from '../../../assets/Song Phraek/img2.jpg'
import AtvRideImg from '../../../assets/Song Phraek/img3.jpg'
import WildlifeSafariImg from '../../../assets/Elephant care/img3.jpg'
import ThaiCookingClassImg from '../../../assets/Krabi Thai Cookery/img2.jpg'
import ShootingRangeImg from '../../../assets/Shooting Range/img1.jpg'
import RockClimbingImg from '../../../assets/King Climbers/img4.jpg'

const images = {
  'snorkeling': SnorkelingImg,
  'scuba-diving': ScubaDivingImg,
  'canoeing': CanoeingImg,
  'kayaking': KayakingImg,
  'zipline': ZiplineImg,
  'atv-ride': AtvRideImg,
  'wildlife-safari': WildlifeSafariImg,
  'thai-cooking-class': ThaiCookingClassImg,
  'shooting-range': ShootingRangeImg,
  'rock-climbing': RockClimbingImg,
}

function TourTypes() {
  const { t } = useTranslation()
  const [mounted, setMounted] = useState(false)
  const [hoveredIndex, setHoveredIndex] = useState(null)

  // Grab the entire tourTypes subtree as an object
  const tourTypes = t('tourTypes', { returnObjects: true })
  const tourSection = t('homepage.tourTypesSection', { returnObjects: true })
  const tourMeta = t('homepage.tourTypesMeta', { returnObjects: true })

  useEffect(() => {
    setMounted(true)
  }, [])

  return (
    <section className={`mx-auto mt-8 w-[94%] max-w-6xl ${mounted ? 'opacity-100' : 'opacity-0'}`} style={{ transition: 'opacity .45s ease' }} aria-label='Tour types'>
      <div className='mobile-sticky-section-heading mb-6 flex flex-wrap items-end justify-between gap-3 rounded-3xl bg-white/90 px-3 py-3 backdrop-blur-md sm:bg-transparent sm:px-0 sm:py-0 sm:backdrop-blur-0'>
        <div>
          <h2 className='text-3xl font-black tracking-tight text-slate-900 sm:text-4xl'>{tourSection?.title}</h2>
          <p className='mt-2 max-w-2xl text-sm text-slate-600 sm:text-base'>{tourSection?.description}</p>
        </div>
        <button className='inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50' onClick={() => (window.location.href = '/packages')}>
          {tourSection?.button}
          <FiArrowUpRight />
        </button>
      </div>

      <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5'>
        {Object.entries(tourTypes).map(([key, { title }], i) => (
          <button
            className='group mobile-sticky-card relative isolate overflow-hidden rounded-3xl border border-slate-200 bg-white text-left shadow-[0_12px_28px_rgba(15,23,42,0.10)] transition hover:-translate-y-1 hover:rounded-3xl hover:shadow-[0_20px_40px_rgba(15,23,42,0.18)] active:rounded-3xl focus:rounded-3xl'
            key={i}
            onClick={() => (window.location.href = '/packages')}
            aria-label={`Explore ${title} tours`}
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
            style={{ '--sticky-top': `${88 + (i * 12)}px` }}
          >
            <div className='relative aspect-[16/9] overflow-hidden rounded-[inherit] sm:aspect-square'>
              <img
                src={images[key]}
                alt={`${title} - Krabi tour type`}
                className='h-full w-full rounded-[inherit] object-cover [backface-visibility:hidden]'
                loading='lazy'
                style={{
                  transform: hoveredIndex === i ? 'scale(1.08)' : 'scale(1)',
                  transition: 'transform .35s ease, filter .35s ease',
                  willChange: 'transform, filter',
                  filter: hoveredIndex === i ? 'brightness(0.8)' : 'brightness(0.92)'
                }}
              />
              <div className='absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/20 to-transparent' />
              <div className='absolute left-3 top-3 rounded-full border border-white/40 bg-slate-900/35 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-white/95 backdrop-blur-sm'>
                {tourMeta?.[key]?.category}
              </div>
              <div className='absolute inset-x-0 bottom-0 p-3'>
                <span className='line-clamp-2 text-base font-bold text-white'>{title}</span>
                <p className='my-1 line-clamp-1 text-xs text-slate-100/90'>{tourMeta?.[key]?.highlight}</p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </section>
  )
}

export default TourTypes
